import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import backgroundDSM from '../assets/dsmAssets/backgroundDSM.svg';
import dsmFirmenichLogo from '../assets/dsmAssets/dsmFirmenichLogo.svg';
import HowToInteract from './HowToInteract';

const buttonStyle = {
    color: 'white',
    fontWeight: 'bold',
    fontSize: { xs: 'calc(1.0vsh + 1.7vw)', sm: 'calc(1.0vh + 2.0vw)', md: 'calc(1vh + 1.8vw)' },
    marginTop: { xs: 'calc(1.0vsh + 1.7vw)', sm: 'calc(1.0vh + 2.0vw)', md: 'calc(1vh + 1.4vw)' },
    borderRadius: '50px',
    boxShadow: '0 8px 12px rgba(0, 0, 0, 0.1)',
    transition: 'background-color 0.3s ease',
    border: '2px solid white',
    background: 'transparent',
    textTransform: 'none',
    fontStyle: 'italic',
    width: 'calc(12vh + 25vw)',
    '&:hover': {
        border: '2px solid white',
        background: 'rgba(255, 255, 255, 0.1)',
    },
};

interface MainMenuProps {
    onStartAR: () => void;
}

const MainMenu: React.FC<MainMenuProps> = ({ onStartAR }) => {
    const [showHowTo, setShowHowTo] = useState(false);

    if (showHowTo) {
        return (
            <Box
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundImage: `url(${backgroundDSM})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'left center',
                    zIndex: 1000,
                    '@media (orientation: landscape)': {
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    },
                }}
            >
                <HowToInteract 
                    onBack={() => setShowHowTo(false)}
                    onExplore={onStartAR}
                />
            </Box>
        );
    }

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundImage: `url(${backgroundDSM})`,
                backgroundSize: 'cover',
                backgroundPosition: 'left center',
                gap: '20px',
                zIndex: 1000,
                '@media (orientation: landscape)': {
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                },
            }}
        >
            <img 
                src={dsmFirmenichLogo}
                alt="DSM Firmenich Logo"
                style={{
                    width: '60%',
                    maxWidth: '400px',
                    marginBottom: '40px',
                    filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))'
                }}
            />
            
            <Button
                variant="outlined"
                onClick={() => setShowHowTo(true)}
                sx={buttonStyle}
            >
                How to interact
            </Button>

            <Button
                variant="outlined"
                onClick={onStartAR}
                sx={buttonStyle}
            >
                Explore our strategy
            </Button>
        </Box>
    );
};

export default MainMenu;
